// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tszohmrldhhdsasapbiz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "sb_publishable_HY4BAVEWX0qrFXJVUjUgYQ_u31YxfZ8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    ...(typeof window !== "undefined" ? { storage: localStorage } : {}),
    persistSession: typeof window !== "undefined",
    autoRefreshToken: true,
  }
});
